import type { Resource } from '@/features/resource/types'

/**
 * Whether this resource's port error values are still being updated — not whether they are returned,
 * since the API sends them either way. When this is false the table drops the column, the graph node
 * drops its dot, the field panel omits the row, and the section says why.
 *
 * Their only producer is the monolith polling the controller, and migrating a resource to LOCAL
 * takes the controller out of that polling. Nothing else writes those fields, so they freeze at
 * whatever was last observed, and a stale error is indistinguishable from a live one. There is no
 * LOCAL replacement to fall back to: the controller reports steerability keyed by `resourceId`, so
 * per-port error state does not exist to be surfaced.
 *
 * Only an explicit LOCAL removes it. Absent means the mode has not arrived rather than that it is
 * LOCAL, and a resource whose mode we do not yet know must not silently lose a column that is
 * load-bearing for every CLOUD resource.
 */
export function deviceErrorsAreLive(resource: Pick<Resource, 'controlMode'>): boolean {
  return resource.controlMode !== 'LOCAL'
}
